export  const getRandomColor = ()  => {
  const colors = ['#f44336', '#3f51b5', '#4caf50', '#ff9800', '#009688', '#9c27b0'];
  return colors[Math.floor(Math.random() * colors.length)];
}